<template lang="pug">
a(:href="trustpilotURL" style="text-decoration: none;" target="_blank")
  div(v-if="stacked" :class="$style.trustpilotContainerStacked")
    img(
      class="w-[90px] mt-[-1px]"
      src="~/assets/img/trustpilot/brand/logo.svg"
      alt="Trustpilot")
    p.justify-self-center.text-black70.m-0 {{ formattedTrustpilotCustomers }}
    img(
      :class="$style.stackedTrustpilotRating"
      src="~/assets/img/trustpilot/brand/stars-4.5.svg"
      alt="Trustpilot")
  div(v-else :class="$style.trustPilotContainer")
    img(
      src="~/assets/img/trustpilot/brand/logo.svg"
      alt="Trustpilot"
      class="justify-self-end mt-[-3px]")
    p.justify-self-center.text-black70.m-0 {{ formattedTrustpilotCustomers }}
    img(
      src="~/assets/img/trustpilot/brand/stars-4.5.svg"
      alt="Trustpilot")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TrustpilotBase from "~/components/base/trustpilotBase"

export default defineComponent({
  name: "TrustPilotWidget",
  extends: TrustpilotBase,
  props: {
    stacked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedTrustpilotCustomers(): string {
      return formatNumberWithLocale(this.trustpilotCustomers, this.$i18n.locale)
    }
  }
})
</script>

<style lang="css" module>
.trustPilotContainer {
  @apply bg-white grid max-w-[350px] p-ds-sm rounded-md cursor-pointer;
  grid-template-columns: repeat(3, 1fr);
}
.trustpilotContainerStacked {
  @apply grid gap-x-ds-md gap-y-ds-sm;
  grid-template-columns: repeat(2, 1fr);
}
.stackedTrustpilotRating {
  @apply max-h-ds-lg;
  grid-column: 1 / -1;
}
</style>
